import { render, staticRenderFns } from "./WasteInputPanel.vue?vue&type=template&id=37d3e453&"
import script from "./WasteInputPanel.vue?vue&type=script&lang=js&"
export * from "./WasteInputPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports